import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

import Site from 'stores/Site'

import Page from 'classes/Page'

export default class Software extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initTabs()
    }

    initTabs() {
        if (Site.isMobile) return

        const el = Site.page.querySelector('.software-tabs')
        const panesWrapper = el.querySelector('.tab-panes')
        this.btns = el.querySelectorAll('.tab-button')
        this.panes = el.querySelectorAll('.tab-pane')
        const heights = []

        this.panes.forEach(pane => {
            heights.push(pane.offsetHeight)
        })

        gsap.set(panesWrapper, {
            minHeight: Math.max(...heights)
        })

        this.panes.forEach(pane => {
            pane.classList.add('loaded')
        })

        this.btns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('active')) return

                this.toggle(btn.getAttribute('data-id'))
            })
        })
    }

    toggle(id) {
        this.btns.forEach(btn => {
            btn.classList.remove('active')

            if (btn.getAttribute('data-id') === id) {
                btn.classList.add('active')
            }
        })

        this.panes.forEach(pane => {
            pane.classList.remove('active')

            if (pane.getAttribute('data-id') === id) {
                pane.classList.add('active')
            }
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}